/**
 * Sales Orders CopilotKit Suggestions
 * Context-aware AI suggestions for sales orders
 */

import { useCopilotChatSuggestions } from '@copilotkit/react-ui'
import { useSelector } from '@ufc/core'
import { selectSalesOrderStats } from '../store/sales-orders.selectors'

export function useSalesOrdersSuggestions() {
  const stats = useSelector(selectSalesOrderStats)

  useCopilotChatSuggestions({
    instructions: `Based on the sales orders data:
    - ${stats.active} sales orders are currently active
    - ${stats.completed} sales orders are completed
    - Total sales order value: ${stats.totalValue.amount.toLocaleString()} ${stats.totalValue.currency}

    Suggest relevant actions the user might want to take.`,
    minSuggestions: 2,
    maxSuggestions: 4,
  })
}

// Legacy alias for backwards compatibility
export const useContractsSuggestions = useSalesOrdersSuggestions
